import React, { ReactElement, ReactNode } from 'react';

export enum LINK_TYPE {
    FACR_WEB,
    IS1,
}

/*
    Represents a link to download a document (external one from FAČR, or internal one from the old IS)
 */
const DocumentItem = ({
    url,
    children,
    linkType,
    is1Url,
    newWindow = false,
}: Props): ReactElement => {
    let host = '';

    switch (linkType) {
        case LINK_TYPE.FACR_WEB:
            host = 'https://facr.fotbal.cz';
            break;

        case LINK_TYPE.IS1:
            host = is1Url;
            break;

        default:
            console.error(`Unsupported link type ${LINK_TYPE}`);
    }
    const href = host + url;
    return (
        <li>
            <a
                href={href}
                {...(newWindow && { target: '_blank', rel: 'noreferrer' })}
            >
                {children}
            </a>
        </li>
    );
};

interface Props {
    url: string;
    children: ReactNode;
    linkType: LINK_TYPE;
    is1Url?: string;
    newWindow?: boolean;
}

export default DocumentItem;
